export class IPlanName
{
    planId:number;
    planName:string;
    payerPlanCode:string;
    isActive:boolean;
    sourceId:string;
    dbOperation:string;
    activeStatus:string;
    selected: boolean;
}